module.exports = __webpack_public_path__ + "media/images/login-bg4-59b351b088eeaca7539aa84053c0dbfc.svg";